// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/26172
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 26172 
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils'
interface IExpoTrackParamsRecord {
  /** 继续支付弹层曝光 */
Cashier_Pop_Expo: {
/** 订单id  */
orderId: string}
  /** 支付按钮曝光 */
Cashier_Pop_PayExpo: {
/** 订单id  */
orderId: string,
/** 支付方式  */
payWay: string,
/** 渠道名称  */
channelName: string}
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** 继续支付弹层曝光 */
  Cashier_Pop_Expo:'Cashier_Pop_Expo',
/** 支付按钮曝光 */
  Cashier_Pop_PayExpo:'Cashier_Pop_PayExpo',
})

interface IClickTrackParamsRecord {
  /** 继续支付弹层支付方式选择 */
Cashier_Pop_PayWay: {
/** 支付方式  */
payWay: string,
/** 订单id  */
orderId: string,
/** 渠道名称  */
channelName: string}
  /** 支付按钮点击 */
Cashier_Pop_Pay: {
/** 订单id  */
orderId: string,
/** 支付方式  */
payWay: string,
/** 渠道名称  */
channelName: string}
}

const sendClickTrack = {
  /** 点击事件上报-继续支付弹层支付方式选择 */
Cashier_Pop_PayWay: (json_param: IClickTrackParamsRecord['Cashier_Pop_PayWay']) => {
    eventTrackingUtils.submitCL({event_id:'Cashier_Pop_PayWay',json_param});
  },
  /** 点击事件上报-支付按钮点击 */
Cashier_Pop_Pay: (json_param: IClickTrackParamsRecord['Cashier_Pop_Pay']) => {
    eventTrackingUtils.submitCL({event_id:'Cashier_Pop_Pay',json_param});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
}
export type {
  IExpoTrackParamsRecord,
}